import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import ApiClient from "../../apis/Api-client";
import { END_POINT } from "../../utils/End-points";
import { errorToster, successToster } from "../../shared/toster/Toster";
import { useTranslation } from "react-i18next";
import { Helper } from "../../utils/Helpers";
import { Can, FEATURES, ACTIONS } from "../../core/permissions";
import RefundDialog from "../refund/RefundDialog";
const { getLocalTimeFromUtc } = new Helper();

const CancelReservationModal = ({
  bookingData,
  handleClosePopover = () => {},
  reset = () => {},
  handleCloseModal = () => {},
}) => {
  const { t } = useTranslation();
  const { api } = ApiClient();
  const [cancelReasons, setCancelReasons] = useState([]);
  const [status_reason_id, setStatus_reason_id] = useState();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showRefundDialog, setShowRefundDialog] = useState(false);
  const [refundableAmount, setRefundableAmount] = useState(0);
  const [advancePaymentAmount, setAdvancePaymentAmount] = useState(0);
  const { reservation_id, booking_id, name, mobile, email, room_data } =
    bookingData;

  useEffect(() => {
    getCancelReasons();
  }, []);

  useEffect(() => {
    if (!booking_id) return;
    api
      .get(END_POINT.PAYMENT.GET_PAYMENT_DETAIL_BY_BOOKING + booking_id)
      .then((res) => {
        setAdvancePaymentAmount(
          Number(res?.data?.data?.total_paid_amount || 0)
        );
      })
      .catch(() => {});
  }, [booking_id]);

  const getCancelReasons = async () => {
    try {
      const cancelReason = await api.get(
        END_POINT.STATUS.GET_ALL_CANCELLATION_REASON
      );
      setCancelReasons(cancelReason?.data?.data || []);
    } catch (error) {
    }
  };

  const handleCancelReservation = async () => {
    try {
      setIsSubmitted(true);

      const bookedRooms = room_data?.map((v) => ({
        room_type_name: v.room_type_name,
        expected_checkin_date: getLocalTimeFromUtc(v.expected_checkin_date)
          ?.dateTimeString,
        expected_checkout_date: getLocalTimeFromUtc(v.expected_checkout_date)
          ?.dateTimeString,
      }));

      const status_reason = cancelReasons?.find(
        (reason) => reason.status_reason_id === status_reason_id
      )?.status_reason;

      const response = await api.post(
        END_POINT.RESERVATION.CANCEL_RESERVATION,
        {
          name,
          mobile,
          email,
          reservation_id: !!reservation_id ? reservation_id : null,
          booking_id,
          status_reason_id,
          status_reason,
          room_data: bookedRooms,
        }
      );
      if (response.status == 200 || response.status == 202) {
        handleClosePopover();
        if (!response.data?.__approvalPending) {
          successToster(
            <span
              dangerouslySetInnerHTML={{
                __html: t("pages.booking_form.toast.reservation_cancelled", {
                  name: bookingData?.name,
                }),
              }}
            />
          );
          if (booking_id) {
            try {
              const paymentRes = await api.get(
                END_POINT.PAYMENT.GET_PAYMENT_DETAIL_BY_BOOKING + booking_id
              );
              const totalPaid = Number(paymentRes?.data?.data?.total_paid_amount || 0);
              if (totalPaid > 0) {
                setRefundableAmount(totalPaid);
                setShowRefundDialog(true);
                return;
              }
            } catch (e) {}
          }
        }
        reset();
      }
    } catch (error) {
      if (!error?.approvalPending) {
        errorToster(error?.response?.data?.msg || "Something went wrong!");
      }
    } finally {
      setIsSubmitted(false);
    }
  };

  return (
    <>
    <Box
      sx={{
        width: { xs: "85.051vw", sm: "50.564vw", md: "26.389vw" },
        margin: "0 auto",
      }}
    >
      <Typography
        sx={{
          fontSize: { md: "1.12vw" },
          fontWeight: 500,
          color: "#252525",
          ml: { xs: "12px", sm: 0 },
          marginTop: { xs: "5vw", sm: 0 },
        }}
      >
        {t(
          "common_components.cancel_reservation.reason_for_reservation_cancel"
        )}
      </Typography>
      {advancePaymentAmount > 0 && (
        <Typography
          sx={{
            fontSize: { xs: "3.26vw", sm: "1.6vw", md: "0.9vw" },
            color: "#DB563F",
            ml: { xs: "12px", sm: 0 },
            marginTop: "3%",
          }}
        >
          {t("common_components.payments.active_payment_warning", {
            amount: advancePaymentAmount,
          })}
        </Typography>
      )}
      <FormControl size="small" fullWidth sx={{ margin: "7% 0 10% 0" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "none" },
            alignItems: { xs: "center", sm: "none" },
            width: "100%",
          }}
        >
          <InputLabel
            sx={{
              marginLeft: { xs: "2.364vw", sm: "auto" },
              fontSize: {
                xs: "3.26vw",
                sm: "2vw",
                md: "1vw",
              },
            }}
          >
            {t("common_components.cancel_reservation.select_reason")}
          </InputLabel>
          <Select
            fullWidth
            value={status_reason_id}
            label={t("common_components.cancel_reservation.select_reason")}
            onChange={(e) => setStatus_reason_id(e?.target?.value)}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: { xs: "60vw", sm: "50vw", md: "20vw" },
                  width: { xs: "80.051vw", sm: "45.564vw", md: "26.389vw" },
                },
              },
            }}
            sx={{
              border: "8px",
              width: { xs: "95%", sm: "100%" },
              "& .MuiSelect-select": {
                fontSize: { md: "1.11vw" },
              },
              "& .MuiMenuItem-root": {
                fontSize: { md: "1.11vw" },
              },
            }}
            slotProps={{
              input: {
                fontSize: { md: "0.12vw" },
              },
            }}
          >
            {cancelReasons?.map((reason) => (
              <MenuItem
                value={reason.status_reason_id}
                sx={{
                  fontSize: {
                    xs: "3.26vw",
                    sm: "2vw",
                    md: "1vw",
                    color: "#606060",
                  },
                }}
              >
                {t(
                  `common_components.cancel_reservation.reasons.${reason.status_reason
                    .toLowerCase()
                    .replace(/\s+/g, "_")}`
                )}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </FormControl>
      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "space-around", sm: "space-between" },
          alignItems: "center",
          margin: "0 auto",
          gap: { xs: "10px", sm: 0 },
          marginBottom: { xs: "7vw", sm: "3vw", md: 0 },
        }}
      >
        <Button
          onClick={handleCloseModal}
          variant="outlined"
          sx={{
            width: { xs: "43%", sm: "48%" },
            fontWeight: 700,
          }}
        >
          {t(`common_components.cancel_reservation.cancel`)}
        </Button>
        <Can
          feature={FEATURES.RESERVATIONS}
          action={ACTIONS.CANCEL_RESERVATION}
        >
          <Button
            variant="contained"
            disabled={!status_reason_id || isSubmitted}
            onClick={handleCancelReservation}
            sx={{
              width: { xs: "43%", sm: "48%" },
              fontWeight: 700,
            }}
          >
            {t(`common_components.cancel_reservation.confirm`)}
          </Button>
        </Can>
      </Box>
    </Box>
    <RefundDialog
      open={showRefundDialog}
      onClose={() => { setShowRefundDialog(false); reset(); }}
      bookingId={booking_id}
      maxRefundable={refundableAmount}
      defaultReason="RESERVATION_CANCELLED"
      defaultAmount={refundableAmount}
      onSuccess={() => { reset(); }}
    />
    </>
  );
};

export default CancelReservationModal;









